import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-title-button"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add", -1)
const _hoisted_5 = { class: "table table-hover align-middle mt-4" }
const _hoisted_6 = { class: "border-dark border-bottom pb-2" }
const _hoisted_7 = { class: "border-dark border-bottom" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  colspan: 4,
  class: "fw-bold small text-uppercase text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_title = _resolveComponent("base-title")!
  const _component_alert_error = _resolveComponent("alert-error")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_ReservationCampaignsOverviewItem = _resolveComponent("ReservationCampaignsOverviewItem")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_base_title, {
        title: _ctx.$t('reservationCampaigns'),
        "help-text": _ctx.$t('descriptionReservationCampaignsOverview'),
        mb: 3
      }, {
        buttons: _withCtx(() => [
          (_ctx.AuthContext.isDpUser())
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (this.newOzempicCampaign && this.newOzempicCampaign(...args)), ["prevent"])),
                  class: "btn btn-hover icon-link text-green"
                }, [
                  _hoisted_2,
                  _createTextVNode(_toDisplayString(_ctx.$t('newOzempicCampaign')), 1)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (this.newRsvCampaign && this.newRsvCampaign(...args)), ["prevent"])),
                  class: "btn btn-hover icon-link text-green"
                }, [
                  _hoisted_3,
                  _createTextVNode(_toDisplayString(_ctx.$t('newRsvCampaign')), 1)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (this.newCovidVaccinationCampaign && this.newCovidVaccinationCampaign(...args)), ["prevent"])),
                  class: "btn btn-hover icon-link text-green"
                }, [
                  _hoisted_4,
                  _createTextVNode(_toDisplayString(_ctx.$t('newCovidVaccinationCampaign')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title", "help-text"]),
      _createVNode(_component_alert_error, {
        exceptions: this.exceptions,
        class: "mb-3"
      }, null, 8, ["exceptions"]),
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", _hoisted_6, [
          _createElementVNode("tr", _hoisted_7, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('title')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('reservationPeriod')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('status')), 1),
            _hoisted_8
          ])
        ]),
        _createElementVNode("tbody", null, [
          (!_ctx.isReady)
            ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                key: 0,
                "n-cols": 4
              }))
            : (!_ctx.hasReservationCampaigns)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t('noContentFound')), 1)
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.reservationCampaigns, (reservationCampaign) => {
                  return (_openBlock(), _createBlock(_component_ReservationCampaignsOverviewItem, {
                    key: reservationCampaign.id,
                    "reservation-campaign": reservationCampaign,
                    onDeleteReservationCampaign: _ctx.deleteCampaign
                  }, null, 8, ["reservation-campaign", "onDeleteReservationCampaign"]))
                }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}